import _ from 'lodash';

import {
    getCustomerApplicationState,
    isSoleTrader,
    getSplitTestValue
} from './selectors';
import { businessDetailsFormValidation } from '../containers/BusinessIntroduction/businessDetailsSchema';
import * as businessIntroductionSchemasDE from '../containers/BusinessIntroductionDE/schema';
import * as personalInformationSchemas from '../containers/PersonalInformation/schema';
import * as personalInformationSchemasDE from '../containers/PersonalInformationDE/schema';
import { isLimitedCompany } from '../helpers/helpers';
import {
    getCountryCode,
    isDirectUKCustomer
} from '../lendingAPI/lendingAPISelector';

export const dataRequirement = {
    incompleteCompanyInfo: 'incomplete_company_info',
    incompletePersonalInfo: 'incomplete_personal_info',
    incompletePrivacyPolicyDE: 'incomplete_privacy_policy_de',
    completeMinRequirement: 'complete_min_requirement'
};

/**
 * Check for minimum data requirement is met for both company and people information.
 *
 * @param {Object} state
 * @returns {string}
 */
export default async function minimumDataRequirement(state) {
    const customer = getCustomerApplicationState(state);
    const country = getCountryCode(state);
    if (country === 'de') {
        try {
            await businessIntroductionSchemasDE.minDataReqCompanyInfoDE.validate(
                customer.company,
                { context: {} } // Context are required for company_name validation for onManualCompanySearch
            );
        } catch {
            return dataRequirement.incompleteCompanyInfo;
        }

        try {
            await personalInformationSchemasDE.minDataReqPersonalInfoDE.validate(
                customer.people[0]
            );
        } catch {
            return dataRequirement.incompletePersonalInfo;
        }
    }

    if (customer.company.type === '')
        return dataRequirement.incompleteCompanyInfo;

    if (isLimitedCompany(customer)) {
        const isInSplitTestMonthlyRevenue = getSplitTestValue(
            state,
            'monthly_revenue_question'
        );
        const isBusinessDetailsReductionSplitTest =
            getSplitTestValue(state, 'business_details_reduction') &&
            country === 'uk';

        try {
            if (isInSplitTestMonthlyRevenue) {
                await businessDetailsFormValidation({
                    monthlyTurnoverOptional: true
                }).validate(customer.company);
            } else if (!isDirectUKCustomer) {
                await businessDetailsFormValidation({
                    vatOptional: true,
                    soleTrader: true
                }).validate(customer.company);
            } else {
                await businessDetailsFormValidation({
                    vatOptional: isBusinessDetailsReductionSplitTest
                }).validate(customer.company);
            }
        } catch {
            return dataRequirement.incompleteCompanyInfo;
        }

        try {
            await personalInformationSchemas.minDataReqLtd.validate(
                customer.people[0]
            );
        } catch {
            return dataRequirement.incompletePersonalInfo;
        }
    }

    if (isSoleTrader(state)) {
        try {
            await businessDetailsFormValidation({
                soleTrader: true
            }).validate(customer.company);
        } catch (error) {
            return dataRequirement.incompleteCompanyInfo;
        }

        try {
            await personalInformationSchemas.minDataReqSt.validate(
                customer.people[0]
            );
        } catch {
            return dataRequirement.incompletePersonalInfo;
        }
    }

    if (!hasApplicantAgreedPrivacyPolicy(customer) && country === 'de') {
        return dataRequirement.incompletePrivacyPolicyDE;
    }

    return dataRequirement.completeMinRequirement;
}

function hasApplicantAgreedPrivacyPolicy(customer) {
    const applicant = _.find(customer?.people, (person) => {
        return _.includes(person.roles, 'applicant');
    });

    return applicant?.privacy_policy_agreement_date;
}
